module.exports = __webpack_public_path__ + "media/promo/panasonic/images/hero-logo-44884cae01c0d0049b0cb18bba00ca48.svg";